import $ from 'jquery';
global.$ = global.jQuery = $;

const isDebug = false; //デバッグ
const __c__ = function (a) {
  if (isDebug) {
    console.log(a);
  }
};

const pow = Math.pow,
  sqrt = Math.sqrt,
  sin = Math.sin,
  cos = Math.cos,
  PI = Math.PI,
  c1 = 1.70158,
  c2 = c1 * 1.525,
  c3 = c1 + 1,
  c4 = ( 2 * PI ) / 3,
  c5 = ( 2 * PI ) / 4.5;
// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
  const n1 = 7.5625,
    d1 = 2.75;
  if ( x < 1/d1 ) {
    return n1*x*x;
  } else if ( x < 2/d1 ) {
    return n1*(x-=(1.5/d1))*x + 0.75;
  } else if ( x < 2.5/d1 ) {
    return n1*(x-=(2.25/d1))*x + 0.9375;
  } else {
    return n1*(x-=(2.625/d1))*x + 0.984375;
  }
}
$.extend( $.easing,
  {
    def: 'easeOutQuad',
    swing: function (x) {
      return $.easing[$.easing.def](x);
    },
    easeInQuad: function (x) {
      return x * x;
    },
    easeOutQuad: function (x) {
      return 1 - ( 1 - x ) * ( 1 - x );
    },
    easeInOutQuad: function (x) {
      return x < 0.5 ?
        2 * x * x :
        1 - pow( -2 * x + 2, 2 ) / 2;
    },
    easeInCubic: function (x) {
      return x * x * x;
    },
    easeOutCubic: function (x) {
      return 1 - pow( 1 - x, 3 );
    },
    easeInOutCubic: function (x) {
      return x < 0.5 ?
        4 * x * x * x :
        1 - pow( -2 * x + 2, 3 ) / 2;
    },
    easeInQuart: function (x) {
      return x * x * x * x;
    },
    easeOutQuart: function (x) {
      return 1 - pow( 1 - x, 4 );
    },
    easeInOutQuart: function (x) {
      return x < 0.5 ?
        8 * x * x * x * x :
        1 - pow( -2 * x + 2, 4 ) / 2;
    },
    easeInQuint: function (x) {
      return x * x * x * x * x;
    },
    easeOutQuint: function (x) {
      return 1 - pow( 1 - x, 5 );
    },
    easeInOutQuint: function (x) {
      return x < 0.5 ?
        16 * x * x * x * x * x :
        1 - pow( -2 * x + 2, 5 ) / 2;
    },
    easeInSine: function (x) {
      return 1 - cos( x * PI/2 );
    },
    easeOutSine: function (x) {
      return sin( x * PI/2 );
    },
    easeInOutSine: function (x) {
      return -( cos( PI * x ) - 1 ) / 2;
    },
    easeInExpo: function (x) {
      return x === 0 ? 0 : pow( 2, 10 * x - 10 );
    },
    easeOutExpo: function (x) {
      return x === 1 ? 1 : 1 - pow( 2, -10 * x );
    },
    easeInOutExpo: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        pow( 2, 20 * x - 10 ) / 2 :
        ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
    },
    easeInCirc: function (x) {
      return 1 - sqrt( 1 - pow( x, 2 ) );
    },
    easeOutCirc: function (x) {
      return sqrt( 1 - pow( x - 1, 2 ) );
    },
    easeInOutCirc: function (x) {
      return x < 0.5 ?
        ( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
        ( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
    },
    easeInElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        -pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
    },
    easeOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
    },
    easeInOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        -( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
        pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
    },
    easeInBack: function (x) {
      return c3 * x * x * x - c1 * x * x;
    },
    easeOutBack: function (x) {
      return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
    },
    easeInOutBack: function (x) {
      return x < 0.5 ?
        ( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
        ( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
    },
    easeInBounce: function (x) {
      return 1 - bounceOut( 1 - x );
    },
    easeOutBounce: bounceOut,
    easeInOutBounce: function (x) {
      return x < 0.5 ?
        ( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
        ( 1 + bounceOut( 2 * x - 1 ) ) / 2;
    }
  });

class Accordion {
  constructor(elm) {
    this.elm = elm;
    this.button = this.elm.querySelector(".accordion--btn");
    this.button.addEventListener('click', this.toggle.bind(this));
  }
  
  toggle() {
    const _elm = this.elm;
    const _class = _elm.classList.value;
    
    if(_class.indexOf('open') !== -1) {
      _elm.classList.remove('open');
      const offsetTop = _elm.offsetTop + _elm.offsetParent.offsetTop;
      window.scrollTo({top: offsetTop, behavior: 'smooth'});
    }else{
      _elm.classList.add('open');
    }
  }
}

class Koma {
  constructor(elm) {
    this.elm = elm;
    this.loop = this.elm.dataset.komaLoop !== null ? this.elm.dataset.komaLoop : false;
    this.loop = this.loop === "true";
    this.delay = this.elm.dataset.komaDelay !== null ? this.elm.dataset.komaDelay | 0 : 0;
    this.imgs = elm.querySelectorAll('div');
    this.imgLength = this.imgs.length ? this.imgs.length : 0;
    this.nowCount = 0;
    this.timer = 0;
    this.scrolled = false;
  }
  
  next() {
    const _this = this;
    const nowImg = _this.imgs[_this.nowCount];
    if (!nowImg) return;
    
    _this.imgs.forEach(function (img, index) {
      if(index === _this.nowCount) {
        img.style.opacity = 1;
      }else{
        img.style.opacity = 0;
      }
    });
  }
  
  delayStart(){
    const _this = this;
    const _delayTime = setTimeout(function(){
      clearTimeout(_delayTime);
      _this.start();
    }, _this.delay);
    
  }
  
  start() {
    const _this = this;
    const nowImg = _this.imgs[_this.nowCount];
    if (!nowImg) return;
    const time = nowImg.dataset.komaTime || 1000;
    
    _this.timer = setTimeout(function(){
      _this.nowCount++;
      
      if(_this.nowCount === _this.imgLength) {
        if(_this.loop) {
          _this.nowCount = 0;
          _this.next();
          _this.start();
        }else{
          _this.stop();
        }
      }else{
        _this.next();
        _this.start();
      }
    }, time);
  }
  
  stop() {
    __c__("stop");
  }
  
  scroll() {
    const _this = this;
    if(_this.scrolled) return true;
    
    let scrollY = window.scrollY;
    let windowHeight = window.innerHeight;
    let timing = windowHeight - (windowHeight / 5);
    let target = _this.elm;
    let rect = target.getBoundingClientRect();
    let offsetTop = scrollY + rect.top;
    
    if(scrollY + timing >= offsetTop){
      _this.delayStart();
      _this.scrolled = true;
    }
  }
}

class SetStoreContents {
  #maxDisplayNumber = 4;
  #closedStores = [];
  
  constructor(primary, secondary, region) {
    this.primary = primary;
    this.secondary = secondary;
    this.region = region;
  }
  
  getHTML(data) {
    let isClosed = false;
    const _region = this.region;
    for (let i = 0; i < this.#closedStores.length; i++) {
      if (data.name.indexOf(this.#closedStores[i]) !== -1) {
        isClosed = true;
      }
    }
    
    // サムネイルは img/stores/ 配下・原寸646×563（表示は CSS の object-fit: cover）
    const thumbFile = `thumb${data.id}_${_region}_stores.png`;
    // 公式サイト未支給の店舗は「店舗情報」ボタンを出さない（リンク先のないボタンを置かない）
    const btnHTML = data.url ? `
      <div class="stores--btn"><a href="${data.url}" target="_blank" rel="noopener"><img src="assets/img/btn_store.png" alt="店舗情報" width="207" height="48"><span class="icon--arrow"><img src="assets/img/arrow_more_stores.png" alt="" width="36" height="36"></span></a></div>` : "";
    return `
    <div class="stores-box" data-store-closed="${isClosed}">
      <div class="stores--img"><img src="assets/img/stores/${thumbFile}" alt="${data.name}" width="646" height="563" loading="lazy" decoding="async"></div>
      <p class="stores--name${data.nameclass ? " " + data.nameclass : ""}">${data.htmltext}</p>${btnHTML}
    </div>
    `;
  }
  
  setData(data) {
    const _this = this;
    const _len = data.length;
    
    let primaryHTML = "";
    let secondaryHTML = "";
    
    for (let i = 0; i < _len; i++) {
      if (i < _this.#maxDisplayNumber) {
        primaryHTML += _this.getHTML(data[i]);
      } else {
        if (_this.secondary !== null) {
          secondaryHTML += _this.getHTML(data[i]);
        }
      }
    }

    _this.primary.innerHTML = primaryHTML;
    if (_this.secondary !== null) {
      _this.secondary.innerHTML = secondaryHTML;
    }
  }
}

global._isSP = undefined;

// CSSブレークポイント（828px以下=SP）と同一条件で判定する
const _mqSP = window.matchMedia("(max-width: 828px)");
_isSP = _mqSP.matches;

;(function() {
  const $window = $(window);
  const $html = $("html");
  const $body = $("body");
  const $main = $("#main");
  const $view = $("#view");
  
  const $menu = $("#menu");
  const $menuBtn = $("#btn_menu");
  const NavOpenClose = function () {
    if ($menu.hasClass("open")) {
      $menu.removeClass("open");
      $html.removeClass("is-modal");
    } else {
      $menu.addClass("open");
      $html.addClass("is-modal");
    }
  };
  $menuBtn.on('click', NavOpenClose);
  
  let windowInnerHeight = window.innerHeight;
  let isEventSetAnimation = true;
  let AnimationScroller = null;
  
  const AnimationStart = function ($container) {
    let _$wait = $container.find(".wait");
    _$wait.each(function () {
      const __$this = $(this);
      const __delay = __$this.data("delay") || 0;
      let __timeout = setTimeout(function () {
        __$this
          .removeClass("wait")
          .addClass("animation");
        clearTimeout(__timeout);
      }, __delay)
    });
    
    const _$swing = $container.find(".swing");
    _$swing.each(function () {
      const __$this = $(this);
      const __delay = __$this.data("delay") || 0;
      //console.log(__delay);
      let __timeout = setTimeout(function () {
        Swing(__$this);
        clearTimeout(__timeout);
      }, __delay)
    });
  };
  
  const SetAnimation = function (target) {
    if (_isSP && target.id === "view") {
      console.log('tet');
      return;
    }
    
    let $section = $(".waiting");
    const sectionLen = $section.length;
    let timing, mainHeight, mainTop;
    mainTop = 0;
    
    if (_isSP) {
      timing = windowInnerHeight - (windowInnerHeight / 5);
    } else {
      // $view
      timing = windowInnerHeight - (windowInnerHeight / 5);
    }
    
    if (sectionLen === 0) {
      isEventSetAnimation = false;
    } else {
      for (let i = 0; i < sectionLen; i++) {
        const $wait = $($section[i]);
        let offsetTop = $wait.offset().top;
        let targetPointCheck = null;
        
        targetPointCheck = $window.scrollTop() + timing >= offsetTop && $window.scrollTop() <= offsetTop;
        
        if (targetPointCheck) {
          let _delay = $wait.data("delay");
          if (_delay === void 0) {
            _delay = 0;
          }
          $wait.delay(_delay).queue(function () {
            const __$this = $(this);
            __$this.removeClass("waiting").addClass('animating');
            __$this.dequeue();
          });
        }
      }
    }
  };
  
  // メインのアニメーション
  const StartTopAnimation = function () {
    let _t = setTimeout(function () {
      
      // ScrollAnimatiopn
      AnimationScroller = function (event) {
        if (isEventSetAnimation) SetAnimation(event.currentTarget);
        _koma.forEach(function (element) {
          if (element.__komaInstance) {
            element.__komaInstance.scroll();
          }
        });
      };
      
      AnimationStart($("#kv"));
      
      $window.on("scroll", AnimationScroller);
      $view.on("scroll", AnimationScroller);
      
      clearTimeout(_t);
    }, 100);
  };
  StartTopAnimation();
  
  const _koma = window.document.querySelectorAll('.koma');
  _koma.forEach(function (element) {
    element.__komaInstance = new Koma(element);
  });
  
  const _accordions = window.document.querySelectorAll('.accordion');
  _accordions.forEach(function (element) {
    new Accordion(element);
  });
  
  // PAGETOP BUTTON
  // 「Intro下あたりから追従」: 来店特典ブロック（.intro--cup 上端＝雲形背景）が見え始めたら表示
  // getBoundingClientRect はビューポート基準のため window / #view どちらのスクロールでも共通で使える
  const $pagetop = $(".btn--pagetop");
  const $pagetopTrigger = $(".intro--cup");
  const PageTopScroll = function(){
    if(!$pagetopTrigger.length) return;
    const triggerTop = $pagetopTrigger[0].getBoundingClientRect().top;
    if(triggerTop < window.innerHeight){
      if(!$pagetop.hasClass("appear")){
        $pagetop.addClass("appear");
      }
    }else{
      if($pagetop.hasClass("appear")){
        $pagetop.removeClass("appear");
      }
    }
  };
  $window.on("scroll", PageTopScroll);
  $view.on("scroll", PageTopScroll);
  
  // カードスタック: セクション下端がビューポート下端に達したらピン留め（sticky top = コンテナ高 - 自身高）
  // ピン留め後は直後の .stack-hold（高さ = コンテナ高 × STACK_HOLD）ぶんスクロールしてから次のカードがせり上がる。
  // 下端の注釈が「見えた瞬間に隠れる」のを防ぐための「ため」。カードがコンテナより低い場合は全体が見えているので不要（0）
  const STACK_HOLD = 0.3;
  const $stack = $(".bonus, .first, .second");
  const StackUpdate = function () {
    // _isSP は後段の resize ハンドラで更新されるため、ここでは MQ を直接見る（ブレークポイント跨ぎのリサイズ対策）
    const ch = _mqSP.matches ? window.innerHeight : $view[0].clientHeight;
    $stack.each(function () {
      const h = this.offsetHeight;
      this.style.top = Math.min(0, ch - h) + "px";
      const hold = this.nextElementSibling;
      if (hold && hold.classList.contains("stack-hold")) {
        hold.style.height = (h >= ch ? Math.round(ch * STACK_HOLD) : 0) + "px";
      }
    });
  };
  StackUpdate();
  $window.on("resize", StackUpdate);
  $window.on("load", StackUpdate);

  // ※ 角丸パネル背景のパララックス（.js-plx）は効果が薄いためGA3判断で撤去（2026-09-24）。
  //   パネルの下端ブリード実寸（+120px）は次セクション下に隠れるため温存

  // RESIZE
  $window.on("resize", function () {
    if (_mqSP.matches) {
      _isSP = true;
    } else {
      _isSP = false;
      $menu.removeClass("open");
      $html.removeClass("is-modal");
    }
  });
  
  $(".anchor").on("click", function () {
    const _$this = $(this);
    const href = _$this.attr("href");
    let _$target = $(href);
    // スタック対象はピン留め中に offset が実位置とズレるため、直前の .stack-marker を基準にする
    const _$marker = _$target.prev(".stack-marker");
    if (_$marker.length) {
      _$target = _$marker;
    }
    
    if (_isSP) {
      $menu.removeClass("open");
      $html.removeClass("is-modal");
      $("html, body").stop().animate({scrollTop: _$target.offset().top}, 1500, "easeInOutQuart");
    } else {
      $view.stop().animate({scrollTop: _$target.offset().top - $main.offset().top}, 1500, "easeInOutQuart");
    }
    
    return false;
  });
  
  $body.addClass("loaded");
})();

const _jsonPath = "assets/api/";
// BAKERY・COFFEE × KYOTO・OSAKA の4区分（0918指示: 京都 → 大阪 の順）
const STORE_GROUPS = ["bakery_kyoto", "bakery_osaka", "coffee_kyoto", "coffee_osaka"];
// 表示順のピンポイント調整（2026-10-05 GA3方針: 追加店舗は stores.json の末尾に単純追加し、並びはJSで差し込む）
// { id: 差し込む店舗のid, after: この店舗idの直後に置く }。after の店が無い（除外中など）場合は末尾のまま
const STORE_ORDER = {
  coffee_kyoto: [
    { id: 16, after: 8 },  // Sibling Coffee → シガコーヒー(8) と Sticks Coffee(9) の間
    { id: 17, after: 6 },  // グローブマウンテン珈琲 → Coffee Base BnA(6) と サーカスコーヒー(7) の間
  ],
};

function applyStoreOrder(key, data) {
  (STORE_ORDER[key] || []).forEach(function (rule) {
    const from = data.findIndex(function (s) { return s.id === rule.id; });
    if (from === -1) return;
    const item = data.splice(from, 1)[0];
    const anchor = data.findIndex(function (s) { return s.id === rule.after; });
    if (anchor === -1) { data.push(item); return; }
    data.splice(anchor + 1, 0, item);
  });
  return data;
}
let map;
let infoWindow;
let currentUserPosition;
let isGetCurrentPosition = false;
// 京都競馬場: GoogleマップのPOI表示位置（Geocoding実測 葭島渡場島町32）。フォールバックピンがラベル上に立つ
const kyotoRacetrack = { lat: 34.9070391, lng: 135.7245324 };

global.initMap = function () {
  __c__('initMap');
  if (!document.getElementById("map")) return;
  
  map = new google.maps.Map(document.getElementById("map"), {
    center: kyotoRacetrack,
    zoom: 12,
    mapId: 'DEMO_MAP_ID' // デモ用のMap ID
  });
  
  infoWindow = new google.maps.InfoWindow();
  
  // 店舗リスト・マーカーは位置情報の許可を待たずに描画する
  loadStoresAndCalculateDistances();
  getUserLocation();
}

function getUserLocation() {
  __c__('getUserLocation');
  //const statusDiv = document.getElementById("status");
  
  currentUserPosition = {
    lat: kyotoRacetrack.lat,
    lng: kyotoRacetrack.lng,
  };
  
  // 現在地ピン: まず京都競馬場（フォールバック）に立て、位置情報が取れたら実位置へ移動する
  // （成功時のみ生成だと、拒否時や http のテストサーバー＝位置情報API不可の環境でピンが出ない）
  // 見た目は従来の青ピン（blue-dot）。店舗ピンに埋もれないよう最前面に
  const currentPinImg = document.createElement("img");
  currentPinImg.src = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
  currentPinImg.width = 32;
  currentPinImg.height = 32;
  currentPinImg.alt = "";
  const currentMarker = new google.maps.marker.AdvancedMarkerElement({
    position: currentUserPosition,
    map: map,
    title: "現在地",
    content: currentPinImg,
    zIndex: 1000,
  });
  
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        currentUserPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        
        map.setCenter(currentUserPosition);
        map.setZoom(13);
        currentMarker.position = currentUserPosition;
        isGetCurrentPosition = true;
      },
      (error) => {
        // 拒否・失敗時は京都競馬場中心＆フォールバックピンのまま
        __c__(error);
      },
      { timeout: 5000, maximumAge: 60000 }
    );
  }
}

/**
 * 位置情報取得に失敗した場合のエラーハンドラ
 * @param {boolean} browserHasGeolocation - ブラウザがGeolocationをサポートしているか
 * @param {HTMLElement} statusDiv - ステータス表示用のDOM要素
 * @param {google.maps.LatLng} pos - エラー時に地図の中心とする位置
 */
function handleLocationError(browserHasGeolocation, statusDiv, pos) {
  __c__("handleLocationError");
  /*statusDiv.textContent = browserHasGeolocation
    ? "エラー: 位置情報サービスに失敗しました。許可設定を確認してください。"
    : "エラー: お使いのブラウザは位置情報サービスをサポートしていません。";*/
  alert(browserHasGeolocation
    ? "エラー: 位置情報サービスに失敗しました。許可設定を確認してください。"
    : "エラー: お使いのブラウザは位置情報サービスをサポートしていません。");
  
  map.setCenter(pos);
}

/**
 * store.jsonファイルを非同期で読み込む
 */
async function loadStoresAndCalculateDistances() {
  __c__("loadStoresAndCalculateDistances");
  try {
    const response = await fetch(_jsonPath + 'stores.json');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const stores = await response.json();
    
    let alldata = [];
    STORE_GROUPS.forEach(function (key) {
      // "exclude": 1 の店舗は非掲載（カード・マップとも）。復旧は stores.json のフラグを外すだけ
      const data = applyStoreOrder(key, (stores[key] || []).filter(function (s) { return !s.exclude; }));
      // マーカー色分け用にジャンル（bakery / coffee）を持たせる
      data.forEach(function (s) { s.genre = key.split("_")[0]; });
      const setter = new SetStoreContents(
        document.querySelector('[data-store-content="' + key + '1"]'),
        document.querySelector('[data-store-content="' + key + '2"]'),
        key
      );
      setter.setData(data);
      alldata = alldata.concat(data);
    });
    __c__(alldata);
    
    displayNearbyStores(alldata);
  } catch (error) {
    //document.getElementById("status").textContent = "店舗情報の読み込みに失敗しました。";
    alert("店舗情報の読み込みに失敗しました。");
    console.error("Fetch error:", error);
  }
}

/**
 * フィルタリングされた店舗を地図上にマーカーとして表示する
 * @param {Array<Object>} nearbyStores - 近くの店舗情報の配列
 */
// コーヒー店ピンの配色（Advanced Marker の PinElement に渡す。色変更はここを書き換えるだけ）
const COFFEE_PIN = {
  background: "#8B4513",  // 本体
  borderColor: "#5a2908", // 縁
  glyphColor: "#A0522D",  // 中央の丸
};

function displayNearbyStores(nearbyStores) {
  // Advanced Marker: ベーカリーはデフォルト（Googleマップ標準の赤ピン）、コーヒーは COFFEE_PIN の茶
  nearbyStores.forEach(store => {
    // 住所未支給の店舗（lat/lng が null）はマーカーを打てないのでスキップ
    if (store.lat == null || store.lng == null) return;
    const options = {
      position: {lat: store.lat, lng: store.lng},
      map: map,
      title: store.name,
      gmpClickable: true, // クリックで吹き出しを開くために必須
    };
    if (store.genre === "coffee") {
      options.content = new google.maps.marker.PinElement(COFFEE_PIN);
    }
    const marker = new google.maps.marker.AdvancedMarkerElement(options);
    
    marker.addEventListener("gmp-click", () => {
      const distanceInKm = store.distance ? (store.distance / 1000).toFixed(2) : null;
      const distanceHtml = distanceInKm ? `<p>現在地からの直線距離: 約${distanceInKm} km</p>` : "";
      // 公式サイト未支給の店舗は「店舗詳細」リンクを出さない
      const urlHtml = store.url ? `<p><a href="${store.url}" target="_blank">店舗詳細</a></p>` : "";
      const contentString = `
        <div style="font-family: sans-serif;">
          <h3>${store.name}</h3>
          <p><a href="https://www.google.com/maps/dir/?api=1&origin=${currentUserPosition.lat},${currentUserPosition.lng}&destination=${store.lat},${store.lng}&travelmode=walking" target="_blank">店舗までのルート</a></p>
          ${urlHtml}
          ${distanceHtml}
        </div>
      `;
      infoWindow.setContent(contentString);
      infoWindow.open({ map: map, anchor: marker });
    });
  });
}